// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disclaimer {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
}

.medication-alerts-content.upload-blocking {
  pointer-events: none;
  opacity: 0.7;
}

.alert-type-option {
  padding: 12px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  margin-bottom: 12px;
  background-color: #F9FAFB;
  transition: all 0.2s ease;
}
.alert-type-option:hover {
  background-color: #F3F4F6;
  border-color: #D1D5DB;
}
.alert-type-option:last-child {
  margin-bottom: 0;
}

.alert-type-label {
  font-weight: 600;
  font-size: 14px;
  color: #1F2937;
  cursor: pointer;
}

.alert-type-description {
  margin-left: 28px;
  font-size: 13px;
  line-height: 1.5;
  color: #6B7280;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
}

:host ::ng-deep .gc-form-section .sidebar-form label {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 30px;
  color: #1E38A9;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext {
  height: 54px;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
}
:host ::ng-deep .gc-form-section .sidebar-form .p-inputtext:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea {
  border: 1px solid #D1D5DB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1f2937;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  height: 7rem;
  box-sizing: border-box;
  resize: vertical !important;
  overflow: auto;
}
:host ::ng-deep .gc-form-section .sidebar-form textarea.p-inputtextarea:enabled:focus {
  box-shadow: none;
  border-color: #D1D5DB;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center {
  display: flex !important;
  align-items: center !important;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center p-radioButton {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center p-radioButton ::ng-deep .p-radiobutton {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center p-radioButton ::ng-deep .p-radiobutton .p-radiobutton-box {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep .gc-form-section .sidebar-form .flex.align-items-center label {
  display: inline-flex !important;
  align-items: center !important;
  margin-bottom: 0 !important;
  line-height: 1.5;
  cursor: pointer;
  vertical-align: middle;
}

.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  max-width: 400px;
}

.text-center {
  text-align: center;
}

.assing-agncy {
  height: 54px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 12px 16px;
  display: flex;
}
.assing-agncy .assing-agncy-img {
  width: 32px;
  height: 32px;
  font-size: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff url('agency-icon-blue.8eed463b0cbddad9.svg') no-repeat center center;
  background-size: 45%;
  color: #2d388b;
  text-align: center;
  font-weight: 600;
  flex: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #c7c7c7;
  padding: 4px;
}
.assing-agncy .assing-agncy-filed {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
}

.p-multiselect-wrapper {
  position: relative;
}

:host ::ng-deep .p-multiselect {
  border-radius: 6px;
  border: 1px solid #ced4da;
  padding: 14px 8px;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
}
:host ::ng-deep .p-multiselect .p-multiselect-label-container {
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 24px;
}
:host ::ng-deep .p-multiselect .p-multiselect-label {
  padding: 0;
  font-size: 16px;
  color: #6b7280;
  display: flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 4px;
}
:host ::ng-deep .p-multiselect .p-multiselect-token {
  margin: 0 2px;
}
:host ::ng-deep .p-multiselect .p-multiselect-trigger {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 12px;
  flex-shrink: 0;
}
:host ::ng-deep .p-autocomplete {
  width: 100%;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input {
  width: 100%;
  border: none;
  padding: 0;
}
:host ::ng-deep .p-autocomplete .p-autocomplete-input:focus {
  box-shadow: none;
}
:host ::ng-deep .assing-agncy-filed .p-autocomplete {
  flex: 1;
}
:host ::ng-deep .p-multiselect-panel {
  border-radius: 6px;
  margin-top: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
:host ::ng-deep .p-multiselect-panel .p-multiselect-items {
  padding: 8px;
}

:host ::ng-deep .table-header > .align-items-center.flex:first-child {
  flex: 0 1 auto;
  min-width: 0;
}
:host ::ng-deep .table-header > .align-items-center.flex:first-child h2 {
  white-space: nowrap;
  flex-shrink: 0;
  margin: 0;
}
:host ::ng-deep .table-header .user-label {
  min-width: auto;
  width: auto;
  padding: 0 8px;
  flex-shrink: 0;
}
:host ::ng-deep .table-header .user-label img {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
:host ::ng-deep .table-header .user-label img[src*=medication-alert-icon] {
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(212deg) brightness(97%) contrast(92%);
  width: 24px;
  height: 24px;
}
:host ::ng-deep .table-header .user-label span {
  white-space: nowrap;
}

:host ::ng-deep .button-sm.add-icon,
:host ::ng-deep .button-sm.upload-icon {
  white-space: nowrap;
  min-width: auto;
}
:host ::ng-deep .button-sm.add-icon .p-button-label,
:host ::ng-deep .button-sm.upload-icon .p-button-label {
  white-space: nowrap;
}

:host ::ng-deep .table-header > .align-items-center.flex:last-child .p-button,
:host ::ng-deep .table-header > .align-items-center.flex:last-child p-button .p-button {
  font-size: 0.875rem !important;
  padding: 0.5rem 0.8rem !important;
  min-height: 2.25rem !important;
}
:host ::ng-deep .table-header > .align-items-center.flex:last-child .p-button .p-button-icon,
:host ::ng-deep .table-header > .align-items-center.flex:last-child p-button .p-button .p-button-icon {
  font-size: 0.85rem !important;
}

:host ::ng-deep .bulkUpload-btn.download-library-btn {
  border-color: #6ACE6A !important;
  background: #6ACE6A !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button {
  background: transparent !important;
  border: none !important;
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button .p-button-label {
  color: #ffffff !important;
  white-space: nowrap;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button .p-button-icon {
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button:hover,
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-button:focus {
  background: transparent !important;
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-dropdown .p-dropdown-trigger {
  border-left-color: rgba(255, 255, 255, 0.5) !important;
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-dropdown .p-dropdown-trigger .pi {
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-dropdown:hover .p-dropdown-trigger,
:host ::ng-deep .bulkUpload-btn.download-library-btn .p-dropdown.p-focus .p-dropdown-trigger {
  border-left-color: rgba(255, 255, 255, 0.7) !important;
  color: #ffffff !important;
}
:host ::ng-deep .bulkUpload-btn.download-library-btn:hover {
  background: #7AEC7A !important;
  border-color: #7AEC7A !important;
}

:host ::ng-deep .p-datatable tbody tr td.text-center {
  vertical-align: middle !important;
  padding: 1rem;
  text-align: center;
}
:host ::ng-deep .p-datatable tbody tr td.text-center > .flex {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  height: 100%;
  min-height: 2.5rem;
}
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text {
  width: 2.5rem !important;
  height: 2.5rem !important;
  min-width: 2.5rem !important;
  min-height: 2.5rem !important;
  max-width: 2.5rem !important;
  max-height: 2.5rem !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-shrink: 0;
  position: relative;
}
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text .p-button-icon-right {
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:hover .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:hover .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:hover .p-button-icon-right, :host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:focus .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:focus .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:focus .p-button-icon-right, :host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:active .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:active .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text:active .p-button-icon-right, :host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text.p-focus .p-button-icon,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text.p-focus .p-button-icon-left,
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text.p-focus .p-button-icon-right {
  margin: 0 !important;
  padding: 0 !important;
  transform: translate(-50%, -50%) !important;
  top: 50% !important;
  left: 50% !important;
}
:host ::ng-deep .p-datatable td.text-center .p-button-rounded.p-button-text .p-button-label {
  display: none;
}

:host ::ng-deep .bulkUpload-btn .medication-batch-upload-panel,
:host ::ng-deep .bulkUpload-btn .p-dropdown-panel {
  left: 50% !important;
  right: auto !important;
  transform: translateX(-50%) !important;
}

:host ::ng-deep .upload-summary-dialog .p-dialog-header {
  background-color: #F6F8FF;
  color: #495057;
  border-radius: 6px 6px 0 0;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-title {
  color: #1E38A9;
  font-weight: 600;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-icon,
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-close,
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-close-icon,
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-button-icon {
  color: #6c757d;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-icon:hover,
:host ::ng-deep .upload-summary-dialog .p-dialog-header .p-dialog-header-close:hover {
  color: #495057;
  background-color: #e9ecef;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-content {
  padding-top: 20px;
}
:host ::ng-deep .upload-summary-dialog .p-dialog-footer {
  border-top: 1px solid #D1D5DB;
  padding-top: 20px;
}

.upload-summary-content .upload-summary-success {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;
}
.upload-summary-content .upload-summary-success .upload-summary-success-icon {
  color: #22c55e;
  font-size: 20px;
  flex-shrink: 0;
}
.upload-summary-content .upload-summary-success .upload-summary-info-icon {
  color: #1e38a9;
  font-size: 20px;
  flex-shrink: 0;
}
.upload-summary-content .upload-summary-success .upload-summary-error-icon {
  color: #ef4444;
  font-size: 20px;
  flex-shrink: 0;
}
.upload-summary-content .upload-summary-success .upload-summary-success-text {
  color: #1e38a9;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
}
.upload-summary-content .upload-summary-success .upload-summary-error-text {
  color: #ef4444;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 500;
}
.upload-summary-content .upload-summary-body {
  padding-left: 4px;
}
.upload-summary-content .upload-summary-body .upload-summary-line {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 10px 0;
  font-size: 15px;
  line-height: 1.5;
  color: #374151;
}
.upload-summary-content .upload-summary-body .upload-summary-line em {
  font-size: 18px;
  flex-shrink: 0;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-line-updated .upload-summary-icon-updated {
  color: #1e38a9;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-line-added .upload-summary-icon-added {
  color: #22c55e;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-line-removed .upload-summary-icon-removed {
  color: #ef4444;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-total {
  font-weight: 600;
  margin-top: 14px;
  margin-bottom: 0;
}
.upload-summary-content .upload-summary-body .upload-summary-line.upload-summary-total .upload-summary-icon-total {
  color: #9ca3af;
}
.upload-summary-content .upload-summary-body.upload-summary-error-body .upload-summary-row-error-line {
  margin-bottom: 6px;
}
.upload-summary-content .upload-summary-body.upload-summary-error-body .upload-summary-row-error-line:last-child {
  margin-bottom: 0;
}
.upload-summary-content .upload-summary-body.upload-summary-error-body .upload-summary-row-error-line span {
  font-size: 13px;
  color: #374151;
}

.dropzone {
  position: relative;
  height: 200px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.dropzone .textLink {
  color: #1F2937 !important;
}
.dropzone .textLink u {
  text-decoration: underline;
  margin-left: 4px;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.fileupload-text {
  display: block;
  width: 85%;
  word-wrap: break-word;
}

.status-active {
  color: #6ACE6A;
  font-weight: 600;
}

.status-inactive {
  color: #ff3c3c;
  font-weight: 600;
}

.checkbox-cursor-pointer ::ng-deep .p-checkbox-label {
  cursor: pointer;
}

:host ::ng-deep .table-header .user-label img[alt=app-link-icon] {
  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(212deg) brightness(97%) contrast(92%);
}

.popup-wrapper {
  position: relative;
}

.sidebar-interaction-blocker {
  position: absolute;
  inset: 0;
  z-index: 10;
  background: transparent;
  cursor: not-allowed;
}

.disabled-action {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/medication-alerts/medication-alerts.component.scss","webpack://./src/app/app-link/app-link.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ACCF;;ADEA;EACE,oBAAA;EACA,YAAA;ACCF;;ADGA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;ACAF;ADEE;EACE,yBAAA;EACA,qBAAA;ACAJ;ADGE;EACE,gBAAA;ACDJ;;ADKA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;ACFF;;ADKA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;ACFF;;ADUM;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACPR;ADWM;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACTR;ADUQ;EACE,gBAAA;EACA,qBAAA;ACRV;ADaM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAGA,WAAA;EACA,eAAA;EACA,eAAA;EAGA,YAAA;EACA,sBAAA;EAGA,2BAAA;EACA,cAAA;ACjBR;ADmBQ;EACE,gBAAA;EACA,qBAAA;ACjBV;ADsBM;EACE,wBAAA;EACA,8BAAA;ACpBR;ADsBQ;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;ACpBV;ADsBU;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;ACpBZ;ADsBY;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ACpBd;ADyBQ;EACE,+BAAA;EACA,8BAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;ACvBV;;AD8BA;EACE,mBAAA;EACA,qBAAA;EACA,gBAAA;AC3BF;;AD8BA;EACE,kBAAA;AC3BF;;AD+BA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AC5BF;AD6BE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,qFAAA;EAEA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AC5BJ;AD8BE;EACE,OAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AC5BJ;;ADgCA;EACE,kBAAA;AC7BF;;ADkCE;EACE,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AC/BJ;ADiCI;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AC/BN;ADkCI;EACE,UAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,QAAA;AChCN;ADmCI;EACE,aAAA;ACjCN;ADoCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AClCN;ADsCE;EACE,WAAA;ACpCJ;ADsCI;EACE,WAAA;EACA,YAAA;EACA,UAAA;ACpCN;ADsCM;EACE,gBAAA;ACpCR;AD0CI;EACE,OAAA;ACxCN;AD4CE;EACE,kBAAA;EACA,eAAA;EACA,wCAAA;AC1CJ;AD4CI;EACE,YAAA;AC1CN;;ADiDE;EACE,cAAA;EACA,YAAA;AC9CJ;ADgDI;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AC9CN;ADkDE;EACE,eAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AChDJ;ADiDI;EACE,WAAA;EACA,YAAA;EACA,cAAA;AC/CN;ADiDI;EACE,4HAAA;EACA,WAAA;EACA,YAAA;AC/CN;ADiDI;EACE,mBAAA;AC/CN;;ADqDA;;EAEE,mBAAA;EACA,eAAA;AClDF;ADoDE;;EACE,mBAAA;ACjDJ;;ADuDE;;EAEE,8BAAA;EACA,iCAAA;EACA,8BAAA;ACpDJ;ADsDI;;EACE,6BAAA;ACnDN;;ADyDA;EACE,gCAAA;EACA,8BAAA;ACtDF;ADwDE;EACE,kCAAA;EACA,uBAAA;EACA,yBAAA;ACtDJ;ADwDI;EACE,yBAAA;EACA,mBAAA;ACtDN;ADyDI;EACE,yBAAA;ACvDN;AD2DE;;EAEE,kCAAA;EACA,yBAAA;ACzDJ;AD4DE;EACE,sDAAA;EACA,yBAAA;AC1DJ;AD4DI;EACE,yBAAA;AC1DN;AD8DE;;EAEE,sDAAA;EACA,yBAAA;AC5DJ;AD+DE;EACE,8BAAA;EACA,gCAAA;AC7DJ;;ADqEI;EACE,iCAAA;EACA,aAAA;EACA,kBAAA;AClEN;ADqEM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ACnER;ADyEE;EACE,wBAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;EACA,4BAAA;EACA,6BAAA;EACA,qBAAA;EACA,oBAAA;EACA,+BAAA;EACA,8BAAA;EACA,kCAAA;EACA,cAAA;EACA,kBAAA;ACvEJ;AD0EI;;;EAGE,oBAAA;EACA,qBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;ACxEN;ADgFM;;;;;;;;;EAGE,oBAAA;EACA,qBAAA;EACA,2CAAA;EACA,mBAAA;EACA,oBAAA;ACxER;AD6EI;EACE,aAAA;AC3EN;;ADiFA;;EAEE,oBAAA;EACA,sBAAA;EACA,sCAAA;AC9EF;;ADmFE;EACE,yBAAA;EACA,cAAA;EACA,0BAAA;AChFJ;ADkFI;EACE,cAAA;EACA,gBAAA;AChFN;ADmFI;;;;EAIE,cAAA;ACjFN;ADoFI;;EAEE,cAAA;EACA,yBAAA;AClFN;ADsFE;EACE,iBAAA;ACpFJ;ADuFE;EACE,6BAAA;EACA,iBAAA;ACrFJ;;AD0FE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;ACvFJ;ADyFI;EACE,cAAA;EACA,eAAA;EACA,cAAA;ACvFN;AD0FI;EACE,cAAA;EACA,eAAA;EACA,cAAA;ACxFN;AD2FI;EACE,cAAA;EACA,eAAA;EACA,cAAA;ACzFN;AD4FI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AC1FN;AD6FI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AC3FN;AD+FE;EACE,iBAAA;AC7FJ;AD+FI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AC7FN;AD+FM;EACE,eAAA;EACA,cAAA;AC7FR;ADgGM;EACE,cAAA;AC9FR;ADiGM;EACE,cAAA;AC/FR;ADkGM;EACE,cAAA;AChGR;ADmGM;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;ACjGR;ADmGQ;EACE,cAAA;ACjGV;ADuGM;EACE,kBAAA;ACrGR;ADuGQ;EACE,gBAAA;ACrGV;ADwGQ;EACE,eAAA;EACA,cAAA;ACtGV;;AApeA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAueF;AAreE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;AAueJ;AApeE;EACE,yBAAA;AAseJ;AApeI;EACE,0BAAA;EACA,gBAAA;AAseN;;AAjeA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAoeF;;AAjeA;EACE,cAAA;EACA,UAAA;EACA,qBAAA;AAoeF;;AAjeA;EACE,cAAA;EACA,gBAAA;AAoeF;;AAjeA;EACE,cAAA;EACA,gBAAA;AAoeF;;AAheE;EACE,eAAA;AAmeJ;;AA9dA;EACE,4HAAA;AAieF;;AA7dA;EACE,kBAAA;AAgeF;;AA5dA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;AA+dF;;AA5dA;EACE,YAAA;AA+dF","sourcesContent":[".disclaimer {\n  display: block;\n  font-size: 12px;\n  color: #6b7280;\n  margin-bottom: 4px;\n}\n\n.medication-alerts-content.upload-blocking {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n// Alert type options styling with scrollable descriptions\n.alert-type-option {\n  padding: 12px;\n  border: 1px solid #D1D5DB;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  background-color: #F9FAFB;\n  transition: all 0.2s ease;\n\n  &:hover {\n    background-color: #F3F4F6;\n    border-color: #D1D5DB;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.alert-type-label {\n  font-weight: 600;\n  font-size: 14px;\n  color: #1F2937;\n  cursor: pointer;\n}\n\n.alert-type-description {\n  margin-left: 28px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #6B7280;\n  font-family: 'Montserrat';\n  font-style: normal;\n  font-weight: 400;\n}\n\n// Ensure form fields match user module styling\n:host ::ng-deep {\n  .gc-form-section {\n    .sidebar-form {\n      // Ensure labels match user module style\n      label {\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 30px;\n        color: #1E38A9;\n      }\n\n      // Ensure input fields match user module style\n      .p-inputtext {\n        height: 54px;\n        border: 1px solid #D1D5DB;\n        border-radius: 6px;\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1f2937;\n        &:enabled:focus {\n          box-shadow: none;\n          border-color: #D1D5DB;\n        }\n      }\n\n      // Ensure textarea matches user module style\n      textarea.p-inputtextarea {\n        border: 1px solid #D1D5DB;\n        border-radius: 6px;\n        padding: 12px 16px;\n        font-family: 'Montserrat';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1f2937;\n\n        // Constrain resize so it does not overflow sidebar/container\n        width: 100%;\n        max-width: 100%;\n        min-width: 100%;\n\n        // Set initial height instead of using utility class to allow resizing\n        height: 7rem;\n        box-sizing: border-box;\n\n        // Allow only vertical resize; override any PrimeNG inline/global rules\n        resize: vertical !important;\n        overflow: auto;\n\n        &:enabled:focus {\n          box-shadow: none;\n          border-color: #D1D5DB;\n        }\n      }\n\n      // Ensure radio button labels are centered\n      .flex.align-items-center {\n        display: flex !important;\n        align-items: center !important;\n\n        p-radioButton {\n          display: inline-flex;\n          align-items: center;\n          vertical-align: middle;\n\n          ::ng-deep .p-radiobutton {\n            display: inline-flex;\n            align-items: center;\n            vertical-align: middle;\n\n            .p-radiobutton-box {\n              display: flex;\n              align-items: center;\n              justify-content: center;\n            }\n          }\n        }\n\n        label {\n          display: inline-flex !important;\n          align-items: center !important;\n          margin-bottom: 0 !important;\n          line-height: 1.5;\n          cursor: pointer;\n          vertical-align: middle;\n        }\n      }\n    }\n  }\n}\n\n.wrap-text {\n  white-space: normal;\n  word-wrap: break-word;\n  max-width: 400px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n// Company and Agency field styles\n.assing-agncy {\n  height: 54px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 12px 16px;\n  display: flex;\n  .assing-agncy-img {\n    width: 32px;\n    height: 32px;\n    font-size: 18px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #fff url(../../assets/images/agency-icon-blue.svg) no-repeat\n      center center;\n    background-size: 45%;\n    color: #2d388b;\n    text-align: center;\n    font-weight: 600;\n    flex: 0 0 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #c7c7c7;\n    padding: 4px;\n  }\n  .assing-agncy-filed {\n    flex: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.p-multiselect-wrapper {\n  position: relative;\n}\n\n// Center text in multi-select and autocomplete fields\n:host ::ng-deep {\n  .p-multiselect {\n    border-radius: 6px;\n    border: 1px solid #ced4da;\n    padding: 14px 8px;\n    width: 100%;\n    background: #fff;\n    display: flex;\n    align-items: center;\n    position: relative;\n\n    .p-multiselect-label-container {\n      flex: 1;\n      display: flex;\n      align-items: center;\n      min-height: 24px;\n    }\n\n    .p-multiselect-label {\n      padding: 0;\n      font-size: 16px;\n      color: #6b7280;\n      display: flex;\n      align-items: center;\n      width: 100%;\n      flex-wrap: wrap;\n      gap: 4px;\n    }\n\n    .p-multiselect-token {\n      margin: 0 2px;\n    }\n\n    .p-multiselect-trigger {\n      width: 24px;\n      height: 24px;\n      position: absolute;\n      right: 12px;\n      flex-shrink: 0;\n    }\n  }\n\n  .p-autocomplete {\n    width: 100%;\n\n    .p-autocomplete-input {\n      width: 100%;\n      border: none;\n      padding: 0;\n\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  }\n\n  .assing-agncy-filed {\n    .p-autocomplete {\n      flex: 1;\n    }\n  }\n\n  .p-multiselect-panel {\n    border-radius: 6px;\n    margin-top: 4px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n    .p-multiselect-items {\n      padding: 8px;\n    }\n  }\n}\n\n// Fix heading wrapping by reducing user-label width\n:host ::ng-deep .table-header {\n  > .align-items-center.flex:first-child {\n    flex: 0 1 auto;\n    min-width: 0;\n\n    h2 {\n      white-space: nowrap;\n      flex-shrink: 0;\n      margin: 0;\n    }\n  }\n\n  .user-label {\n    min-width: auto;\n    width: auto;\n    padding: 0 8px;\n    flex-shrink: 0;\n    img {\n      width: 16px;\n      height: 16px;\n      flex-shrink: 0;\n    }\n    img[src*=\"medication-alert-icon\"] {\n      filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(212deg) brightness(97%) contrast(92%);\n      width: 24px;\n      height: 24px;\n    }\n    span {\n      white-space: nowrap;\n    }\n  }\n}\n\n// Fix \"Add New Rule\" / \"Upload Library\" button text wrapping\n:host ::ng-deep .button-sm.add-icon,\n:host ::ng-deep .button-sm.upload-icon {\n  white-space: nowrap;\n  min-width: auto;\n\n  .p-button-label {\n    white-space: nowrap;\n  }\n}\n\n// Cheader buttons to leave room for Delete Selected\n:host ::ng-deep .table-header > .align-items-center.flex:last-child {\n  .p-button,\n  p-button .p-button {\n    font-size: 0.875rem !important;\n    padding: 0.5rem 0.8rem !important;\n    min-height: 2.25rem !important;\n\n    .p-button-icon {\n      font-size: 0.85rem !important;\n    }\n  }\n}\n\n// Download Library\n:host ::ng-deep .bulkUpload-btn.download-library-btn {\n  border-color: #6ACE6A !important;\n  background: #6ACE6A !important;\n\n  .p-button {\n    background: transparent !important;\n    border: none !important;\n    color: #ffffff !important;\n\n    .p-button-label {\n      color: #ffffff !important;\n      white-space: nowrap;\n    }\n\n    .p-button-icon {\n      color: #ffffff !important;\n    }\n  }\n\n  .p-button:hover,\n  .p-button:focus {\n    background: transparent !important;\n    color: #ffffff !important;\n  }\n\n  .p-dropdown .p-dropdown-trigger {\n    border-left-color: rgba(255, 255, 255, 0.5) !important;\n    color: #ffffff !important;\n\n    .pi {\n      color: #ffffff !important;\n    }\n  }\n\n  .p-dropdown:hover .p-dropdown-trigger,\n  .p-dropdown.p-focus .p-dropdown-trigger {\n    border-left-color: rgba(255, 255, 255, 0.7) !important;\n    color: #ffffff !important;\n  }\n\n  &:hover {\n    background: #7AEC7A !important;\n    border-color: #7AEC7A !important;\n  }\n}\n\n// Fix actions column - display edit and delete buttons in a row\n:host ::ng-deep .p-datatable {\n  // Ensure table cells align properly with row height when content wraps\n  tbody tr {\n    td.text-center {\n      vertical-align: middle !important;\n      padding: 1rem;\n      text-align: center;\n\n      // Flex container for buttons\n      > .flex {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        width: 100%;\n        height: 100%;\n        min-height: 2.5rem;\n      }\n    }\n  }\n\n  // Ensure action buttons are properly aligned and centered\n  td.text-center .p-button-rounded.p-button-text {\n    width: 2.5rem !important;\n    height: 2.5rem !important;\n    min-width: 2.5rem !important;\n    min-height: 2.5rem !important;\n    max-width: 2.5rem !important;\n    max-height: 2.5rem !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    display: inline-flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    flex-shrink: 0;\n    position: relative;\n\n    // Override any PrimeNG default icon styles\n    .p-button-icon,\n    .p-button-icon-left,\n    .p-button-icon-right {\n      margin: 0 !important;\n      padding: 0 !important;\n      display: flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n      width: 100% !important;\n      height: 100% !important;\n      line-height: 1 !important;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n\n    // Fix hover, focus, and active states - ensure icon stays centered\n    &:hover,\n    &:focus,\n    &:active,\n    &.p-focus {\n      .p-button-icon,\n      .p-button-icon-left,\n      .p-button-icon-right {\n        margin: 0 !important;\n        padding: 0 !important;\n        transform: translate(-50%, -50%) !important;\n        top: 50% !important;\n        left: 50% !important;\n      }\n    }\n\n    // Remove any label spacing\n    .p-button-label {\n      display: none;\n    }\n  }\n}\n\n// Center dropdown panel below batch upload button (panel appended to container)\n:host ::ng-deep .bulkUpload-btn .medication-batch-upload-panel,\n:host ::ng-deep .bulkUpload-btn .p-dropdown-panel {\n  left: 50% !important;\n  right: auto !important;\n  transform: translateX(-50%) !important;\n}\n\n// Upload summary modal\n:host ::ng-deep .upload-summary-dialog {\n  .p-dialog-header {\n    background-color: #F6F8FF;\n    color: #495057;\n    border-radius: 6px 6px 0 0;\n\n    .p-dialog-title {\n      color: #1E38A9;\n      font-weight: 600;\n    }\n\n    .p-dialog-header-icon,\n    .p-dialog-header-close,\n    .p-dialog-header-close-icon,\n    .p-button-icon {\n      color: #6c757d;\n    }\n\n    .p-dialog-header-icon:hover,\n    .p-dialog-header-close:hover {\n      color: #495057;\n      background-color: #e9ecef;\n    }\n  }\n\n  .p-dialog-content {\n    padding-top: 20px;\n  }\n\n  .p-dialog-footer {\n    border-top: 1px solid #D1D5DB;\n    padding-top: 20px;\n  }\n}\n\n.upload-summary-content {\n  .upload-summary-success {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    margin-bottom: 20px;\n\n    .upload-summary-success-icon {\n      color: #22c55e;\n      font-size: 20px;\n      flex-shrink: 0;\n    }\n\n    .upload-summary-info-icon {\n      color: #1e38a9;\n      font-size: 20px;\n      flex-shrink: 0;\n    }\n\n    .upload-summary-error-icon {\n      color: #ef4444;\n      font-size: 20px;\n      flex-shrink: 0;\n    }\n\n    .upload-summary-success-text {\n      color: #1e38a9;\n      font-size: 15px;\n      line-height: 1.5;\n      font-weight: 500;\n    }\n\n    .upload-summary-error-text {\n      color: #ef4444;\n      font-size: 15px;\n      line-height: 1.5;\n      font-weight: 500;\n    }\n  }\n\n  .upload-summary-body {\n    padding-left: 4px;\n\n    .upload-summary-line {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      margin: 0 0 10px 0;\n      font-size: 15px;\n      line-height: 1.5;\n      color: #374151;\n\n      em {\n        font-size: 18px;\n        flex-shrink: 0;\n      }\n\n      &.upload-summary-line-updated .upload-summary-icon-updated {\n        color: #1e38a9;\n      }\n\n      &.upload-summary-line-added .upload-summary-icon-added {\n        color: #22c55e;\n      }\n\n      &.upload-summary-line-removed .upload-summary-icon-removed {\n        color: #ef4444;\n      }\n\n      &.upload-summary-total {\n        font-weight: 600;\n        margin-top: 14px;\n        margin-bottom: 0;\n\n        .upload-summary-icon-total {\n          color: #9ca3af;\n        }\n      }\n    }\n\n    &.upload-summary-error-body {\n      .upload-summary-row-error-line {\n        margin-bottom: 6px;\n\n        &:last-child {\n          margin-bottom: 0;\n        }\n\n        span {\n          font-size: 13px;\n          color: #374151;\n        }\n      }\n    }\n  }\n}\n","@import \"../medication-alerts/medication-alerts.component.scss\";\n\n.dropzone {\n  position: relative;\n  height: 200px;\n  width: 100%;\n  border: 2px dashed #D1D5DB;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n\n  input {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  .textLink {\n    color: #1F2937 !important;\n\n    u {\n      text-decoration: underline;\n      margin-left: 4px;\n    }\n  }\n}\n\n.fileupload-info {\n  background: #f6f8ff;\n  padding: 15px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.fileupload-text {\n  display: block;\n  width: 85%;\n  word-wrap: break-word;\n}\n\n.status-active {\n  color: #6ACE6A;\n  font-weight: 600;\n}\n\n.status-inactive {\n  color: #ff3c3c;\n  font-weight: 600;\n}\n\n.checkbox-cursor-pointer {\n  ::ng-deep .p-checkbox-label {\n    cursor: pointer;\n  }\n}\n\n// Make AppLink header icon blue (scoped to this component only)\n:host ::ng-deep .table-header .user-label img[alt=\"app-link-icon\"] {\n  filter: brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%)\n    hue-rotate(212deg) brightness(97%) contrast(92%);\n}\n\n.popup-wrapper {\n  position: relative;\n}\n\n// Prevent any interactions while upload/API is in progress\n.sidebar-interaction-blocker {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n  background: transparent;\n  cursor: not-allowed;\n}\n\n.disabled-action {\n  opacity: 0.5;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
